/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu

import * as React from "react";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { ToastContextProvider } from "@myevaluations/myevals-plasmic-utils/dist/ToastContextProvider/ToastContextProvider"; // plasmic-import: _GV0WwXr3SkU/codeComponent
import { ApiContextProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/ApiProvider/ApiContext"; // plasmic-import: -rBf6NhMlsA0/codeComponent

export interface GlobalContextsProviderProps {
  children?: React.ReactElement;
  toastContextProviderProps?: Partial<
    Omit<React.ComponentProps<typeof ToastContextProvider>, "children">
  >;
  apiContextProviderProps?: Partial<
    Omit<React.ComponentProps<typeof ApiContextProvider>, "children">
  >;
}

export default function GlobalContextsProvider(
  props: GlobalContextsProviderProps
) {
  const { children, toastContextProviderProps, apiContextProviderProps } =
    props;

  return (
    <ToastContextProvider
      {...toastContextProviderProps}
      duration={
        toastContextProviderProps && "duration" in toastContextProviderProps
          ? toastContextProviderProps.duration!
          : 5000
      }
    >
      <ApiContextProvider
        {...apiContextProviderProps}
        middlewares={
          apiContextProviderProps && "middlewares" in apiContextProviderProps
            ? apiContextProviderProps.middlewares!
            : undefined
        }
      >
        {children}
      </ApiContextProvider>
    </ToastContextProvider>
  );
}
